document.addEventListener('DOMContentLoaded', () => {
  const siteHeader = document.querySelector('.tco-site-header');
  const headerHeight = siteHeader.getBoundingClientRect().height;

  function headerTransparency() {
    if (window.pageYOffset < headerHeight) {
      siteHeader.classList.remove('tco-site-header--filled');
    }

    window.addEventListener('scroll', function() {
      if( window.pageYOffset > headerHeight ) {
        siteHeader.classList.add('tco-site-header--filled');
      } else {
        siteHeader.classList.remove('tco-site-header--filled');
      }
    });
  }

  if( siteHeader ) {
    headerTransparency();
  }
})